export default {
    apiKey: "AIzaSyCwKkLssbQEvYD0qUYYQ_s2-Hq-JSp-Vac",
    authDomain: "edcan-web-2022.firebaseapp.com",
    projectId: "edcan-web-2022",
    storageBucket: "edcan-web-2022.appspot.com",
    messagingSenderId: "399765369943",
    appId: "1:399765369943:web:4a2d983742bf69e5dd5f12",
    measurementId: "G-LWTRKLXV3S"
};